@if (wsSummary$ | async; as wsSummary) {
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-12">
              <h1 class="font-weight-300" id="workspace-name">
                {{ wsSummary[$workspaceSummary.workspace][$workspace.name] }} {{ 'label_details' | translate }}
              </h1>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="row">
                <div class="col-12">
                  <h2 class="h4">{{ 'label_description' | translate }}</h2>
                </div>
              </div>
              <div class="row">
                <div class="col-12 text-black" id="workspace-desc">
                  {{ wsSummary[$workspaceSummary.workspace][$workspace.description] }}
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-4 text-black">
            <div class="col-12">
              <div class="row">
                <div class="col-12 col-md-auto mb-3 mb-md-0">
                  <div class="row">
                    <div class="col-12">
                      <h2 class="h4">{{ 'digital_properties' | translate }}</h2>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12" id="dp-count">
                      {{ wsSummary[$workspaceSummary.totalDigitalProperties] }}
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-auto mb-3 mb-md-0">
                  <div class="row">
                    <div class="col-12">
                      <h2 class="h4">{{ 'total_scans' | translate }}</h2>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12" id="scan-count">
                      {{ wsSummary[$workspaceSummary.totalScans] }}
                    </div>
                  </div>
                </div>
                <div class="col-12 col-md-auto mb-3 mb-md-0 me-auto">
                  <div class="row">
                    <div class="col-12">
                      <h2 class="h4">{{ 'label_manual_evaluations' | translate }}</h2>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-12" id="manual-eval-count">
                      {{ wsSummary[$workspaceSummary.totalManualEvaluations] }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-4">
            <div class="col-12">
              <div class="row">
                <div class="col-12">
                  <h2 class="h4">{{ 'administrator_users' | translate }}</h2>
                </div>
              </div>
              <div class="row">
                <div class="col-12" id="users">
                  <app-workspace-users-list [workspaceId]="workspaceId"></app-workspace-users-list>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <app-tenant-workspace-digital-properties-list [digitalProperties$]="digitalProperties$">
          </app-tenant-workspace-digital-properties-list>
        </div>
      </div>
    </div>
  </div>
}
